import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(({ variables}) => ({
  list: {
    margin: `${variables?.spacingNone}`,
    padding: `${variables?.spacingD} ${variables?.spacingD}`,
    listStyle: 'none',
  },
}));

export default styles;
